import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminClients() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    http.get("/admin/clients").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="admin-clients">
      <h1 className="text-4xl">Clients</h1>
      <p className="mt-2 text-navy/65">Everyone who has signed in to the client portal.</p>
      <div className="mt-8">
        {loading ? (
          <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="card p-10 text-center"><p className="text-navy/65">No clients have signed in yet. They'll appear here once they use the Google sign-in.</p></div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {items.map((c) => (
              <Link key={c.user_id} to={`/admin/clients/${c.user_id}`} className="card p-5 flex items-center justify-between hover:-translate-y-1 transition" data-testid={`client-${c.user_id}`}>
                <div className="flex items-center gap-3">
                  {c.picture ? <img src={c.picture} alt="" className="w-10 h-10 rounded-full" /> : <div className="w-10 h-10 rounded-full bg-gold/20 text-gold flex items-center justify-center font-medium">{(c.name||"?")[0]}</div>}
                  <div>
                    <div className="text-navy font-medium">{c.name}</div>
                    <div className="text-xs text-navy/55">{c.email}</div>
                  </div>
                </div>
                <ArrowUpRight className="w-4 h-4 text-navy/40" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
